/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof Token
     */
    token: string;
    /**
     * NO_DESCRIPTION
     * @type {Date}
     * @memberof Token
     */
    createdTs: Date;
    /**
     * ID
     * @type {number}
     * @memberof Token
     */
    id: number;
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof Token
     */
    session: string;
    /**
     * NO_DESCRIPTION
     * @type {string}
     * @memberof Token
     */
    role: string;
    /**
     * comments
     * @type {string}
     * @memberof Token
     */
    comments: string;
    /**
     * valid after
     * @type {Date}
     * @memberof Token
     */
    validAfter: Date;
    /**
     * valid before
     * @type {Date}
     * @memberof Token
     */
    validBefore?: Date | null;
}

/**
 * Check if a given object implements the Token interface.
 */
export function instanceOfToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "createdTs" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "session" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "comments" in value;
    isInstance = isInstance && "validAfter" in value;

    return isInstance;
}

export function TokenFromJSON(json: any): Token {
    return TokenFromJSONTyped(json, false);
}

export function TokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): Token {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'createdTs': (new Date(json['created_ts'])),
        'id': json['id'],
        'session': json['session'],
        'role': json['role'],
        'comments': json['comments'],
        'validAfter': (new Date(json['valid_after'])),
        'validBefore': !exists(json, 'valid_before') ? undefined : (json['valid_before'] === null ? null : new Date(json['valid_before'])),
    };
}

export function TokenToJSON(value?: Token | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'created_ts': (value.createdTs.toISOString()),
        'id': value.id,
        'session': value.session,
        'role': value.role,
        'comments': value.comments,
        'valid_after': (value.validAfter.toISOString()),
        'valid_before': value.validBefore === undefined ? undefined : (value.validBefore === null ? null : value.validBefore.toISOString()),
    };
}

